"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _stack = _interopRequireDefault(require("@antv/adjust/lib/stack"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _stack["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@antv/f2/lib/geom/adjust/stack.js
// module id = 394
// module chunks = 3